import React, { useState, useEffect } from 'react';
import { Manage } from '../shared/Manage';
import { KeenIcon } from '@/components'
import { DetailedViewWithPagination } from '../shared/DetailedViewWithPagination';
import { DeleteConfirmModal } from '@/components/DeleteConfirmModal';

// Dữ liệu mẫu
const mockData = [
  {
    id: 1,
    name: 'Lời giới thiệu',
    date: '2/5/2025',
    data: 'Bệnh viện [Tên Bệnh Viện] là đơn vị y tế uy tín, hoạt động với sứ mệnh chăm sóc sức khỏe toàn diện cho cộng đồng. Với đội ngũ y bác sĩ giàu kinh nghiệm, chuyên môn cao cùng hệ thống trang thiết bị hiện đại, chúng tôi cam kết mang đến dịch vụ khám chữa bệnh an toàn, chất lượng và hiệu quả.'
  },
  {
    id: 2,
    name: 'Tầm nhìn',
    date: '3/6/2025',
    data: 'Trở thành bệnh viện hàng đầu khu vực về chất lượng khám chữa bệnh và dịch vụ khách hàng.'
  },
  {
    id: 3,
    name: 'Sứ mệnh',
    date: '4/7/2025',
    data: 'Cung cấp dịch vụ y tế chất lượng cao, lấy người bệnh làm trung tâm, không ngừng đổi mới và phát triển.'
  },
  {
    id: 4,
    name: 'Giá trị cốt lõi',
    date: '5/8/2025',
    data: 'Tận tâm - Chuyên nghiệp - Đổi mới - Hợp tác - Trách nhiệm.'
  },
  {
    id: 5,
    name: 'Đội ngũ bác sĩ',
    date: '6/9/2025',
    data: 'Đội ngũ bác sĩ giàu kinh nghiệm, chuyên môn cao, tận tâm với nghề.'
  }
];

// Cấu hình cột
const columns = [
  { key: 'name', label: 'Name', type: 'text', width: '20%' },
  { key: 'date', label: 'Date Create', type: 'text', width: '20%' },
  { key: 'data', label: 'Data (150 word)', type: 'text', width: '50%' }
];

const ManageReferenceData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Giả lập fetch data
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setData(mockData);
      setLoading(false);
    },200);
  }, []);

  // Xử lý các sự kiện
  const handleEdit = (item) => {
    console.log('Edit item:', item);
    // TODO: logic edit
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    if (selectedItem) {
      setData(prev => prev.filter(i => i.id !== selectedItem.id));
    }
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const cancelAction = () => {
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const totalPages = data.length;

  const handlePrev = () => {
    setCurrentPage((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < totalPages - 1 ? prev + 1 : prev));
  };

  // Sử dụng giá trị trực tiếp cho message xác nhận xóa
  const deleteConfirmMessageText = "Bạn có chắc chắn muốn xóa dữ liệu này không?";

  return (
    <div className="flex flex-col items-center">
      <Manage
        type="reference-data"
        tableProps={{
          data,
          loading,
          columns,
          onEdit: handleEdit,
          onDelete: handleDelete,
          emptyMessage: "Không có dữ liệu",
          deleteConfirmMessage: deleteConfirmMessageText,
        }}
        className="w-full"
      />
      {/* Tiện ích data */}
      <DetailedViewWithPagination
        data={data}
        currentPage={currentPage}
        totalPages={totalPages}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePrev={handlePrev}
        handleNext={handleNext}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        show={showDeleteConfirm}
        message={deleteConfirmMessageText}
        onConfirm={confirmDelete}
        onCancel={cancelAction}
      />
    </div>
  );
};

export { ManageReferenceData };
